import React from 'react'
import Layout from '../../../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const FiberPotentialOnilne = () => {
   const settings = {
        dots: true,
        infinite: true,
        speed: 1500,        // ✅ slower transition (2 seconds)
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500 // ✅ stays 3 seconds before next slide (optional)
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpaperinstrument%2Fimg%2F1770294266279_Fiber%20Potential%20Onilne%20(FPO).png?alt=media&token=5c86460e-10c8-476d-bce3-f22d63426ef3',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpaperinstrument%2Fimg%2F1770294266279_Fiber%20Potential%20Onilne%20(FPO).png?alt=media&token=5c86460e-10c8-476d-bce3-f22d63426ef3'
    ];
    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/paperTesting">Paper Testing</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Fiber Potential Onilne (FPO) </h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Fiber Potential Onilne (FPO) </h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                  The new Online FPO - Fiber Potential Analyzer utilizes the established streaming current potential measuring principle to deliver accurate, fast, and reliable results. This advanced tool, the Emtec FPO, enables precise control and optimization of chemical additive dosages during paper production. It is particularly effective for managing the dosage of starch, wet strength agents, dry strength agents, drainage aids, and other chemical additives.
                                   <br /><br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Fiber Potential Onilne (FPO)"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default FiberPotentialOnilne